/**
 * VDB Priority Navigation - FRECCIA dropdown for overflowing header nav items
 * Always hides the last 6 items on desktop plus any extras that don't fit.
 */

(function () {
  'use strict';
  if (window.vdbPriorityNavLoaded) return;
  window.vdbPriorityNavLoaded = true;

  var CHEVRON_SVG = '<svg width="10" height="6" viewBox="0 0 10 6" fill="none" style="display:inline-block;vertical-align:middle;margin-left:4px;"><path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var MIN_HIDDEN = 4;

  function debounce(fn, ms) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, ms);
    };
  }

  class VDBPriorityNav {
    constructor() {
      this.container = document.querySelector('.header__bottom .header-links');
      this.linkList = this.container ? this.container.querySelector('.link-list') : null;
      if (!this.container || !this.linkList) return;

      this.altriItem = null;
      this.altriList = null;
      this._altriWidth = 0;

      this.init();
    }

    init() {
      this.createAltriItem();

      var self = this;
      window.addEventListener('resize', debounce(function () {
        self.update();
      }, 200));

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () { self.update(); });
      }

      requestAnimationFrame(function () { self.update(); });
      setTimeout(function () { self.update(); }, 400);
      setTimeout(function () { self.update(); }, 900);
    }

    createAltriItem() {
      var li = document.createElement('li');
      li.className = 'has-submenu priority-nav-altri';
      li.style.display = 'none';
      li.innerHTML = [
        '<a href="#" class="menu-link" onclick="event.preventDefault();">',
        '  <span class="text-animation--underline">' + CHEVRON_SVG + '</span>',
        '</a>',
        '<ul class="submenu normal-menu">',
        '  <div class="submenu-holder">',
        '    <ul class="altri-link-list"></ul>',
        '  </div>',
        '</ul>'
      ].join('');

      this.altriItem = li;
      this.altriList = li.querySelector('.altri-link-list');
      this.linkList.appendChild(li);

      // Measure ALTRI width
      li.style.display = '';
      li.style.visibility = 'hidden';
      li.style.position = 'absolute';
      this._altriWidth = li.offsetWidth + 16;
      li.style.display = 'none';
      li.style.visibility = '';
      li.style.position = '';
    }

    getItems() {
      return Array.from(this.linkList.children).filter(function (li) {
        return !li.classList.contains('priority-nav-altri');
      });
    }

    getGap() {
      var style = window.getComputedStyle(this.linkList);
      return parseFloat(style.gap || style.columnGap) || 0;
    }

    getAvailableWidth() {
      return this.container.offsetWidth - 32;
    }

    reset() {
      var items = this.getItems();
      for (var i = 0; i < items.length; i++) {
        items[i].style.display = '';
      }
      this.altriList.innerHTML = '';
      this.altriItem.style.display = 'none';
    }

    update() {
      if (window.innerWidth < 1024) {
        this.reset();
        this.altriItem.style.display = 'none';
        this.container.classList.add('vdb-nav-ready');
        return;
      }

      // Guard: if layout hasn't painted yet, container width will be 0 — bail and retry
      // rather than locking in bestFit=1 and revealing the broken state.
      if (this.container.offsetWidth === 0) {
        var self = this;
        setTimeout(function () { self.update(); }, 100);
        return;
      }

      this.reset();

      var items = this.getItems();
      if (items.length === 0) return;

      var availableWidth = this.getAvailableWidth();
      var altriWidth = this._altriWidth;
      var gap = this.getGap();

      // Calculate total width of all items
      var totalWidth = 0;
      for (var i = 0; i < items.length; i++) {
        totalWidth += items[i].offsetWidth;
      }
      totalWidth += gap * Math.max(0, items.length - 1);

      // Determine how many items fit
      var bestFit = items.length;

      if (totalWidth > availableWidth) {
        bestFit = 0;
        for (var n = 1; n <= items.length; n++) {
          var w = 0;
          for (var j = 0; j < n; j++) {
            w += items[j].offsetWidth;
          }
          w += gap * Math.max(0, n - 1);
          w += altriWidth;

          if (w <= availableWidth) {
            bestFit = n;
          } else {
            break;
          }
        }
        if (bestFit === 0 && items.length > 0) {
          bestFit = 1;
        }
      }

      // Always hide at least MIN_HIDDEN items on desktop
      var maxVisible = Math.max(1, items.length - MIN_HIDDEN);
      bestFit = Math.min(bestFit, maxVisible);

      // Hide overflow items and clone to dropdown (strip submenus)
      for (var k = bestFit; k < items.length; k++) {
        items[k].style.display = 'none';
        var clone = items[k].cloneNode(true);
        clone.removeAttribute('id');
        clone.style.display = '';
        // Remove any nested submenu to prevent dropdown chaos
        var submenu = clone.querySelector('.submenu');
        if (submenu) submenu.remove();
        // Remove has-submenu class since there's no submenu anymore
        clone.classList.remove('has-submenu', 'submenu-is-mega-menu');
        this.altriList.appendChild(clone);
      }

      if (bestFit < items.length) {
        this.altriItem.style.display = '';
      }

      this.container.classList.add('vdb-nav-ready');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      new VDBPriorityNav();
    });
  } else {
    new VDBPriorityNav();
  }
})();
